import React from 'react';
import {SOCIAL_LINKS} from '../../../configs/socialLinks';
import {sendButtonClickEvent} from '../../../analytics/gameAnalytics';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import './MainMenuSocialLinks.css';

/**
 * Соцсети игры в подвале главного меню: иконка площадки и ссылка в стиле
 * остальных ссылок подвала. Это настоящие ссылки, а не кнопки с window.open:
 * так их можно открыть в новой вкладке средней кнопкой или долгим нажатием.
 * Клик, как у PageButton, отмечается в аналитике и озвучивается.
 */
const MainMenuSocialLinks = ({pageId = 'MainMenu', isGuest}) => {
  const handleClick = (link) => {
    sendButtonClickEvent(pageId, link.id, undefined, {isGuest});
    MENU_SOUND_MANAGER.playMenuButtonClick();
  };

  return (
    <div className="main-menu-social-links">
      {SOCIAL_LINKS.map((link) => (
        <a
          key={link.id}
          className="main-menu-social-links_link"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleClick(link)}
        >
          <img className="main-menu-social-links_icon" src={link.iconPath} alt="" draggable={false}/>
          <span className="main-menu-social-links_label">{link.label}</span>
        </a>
      ))}
    </div>
  );
};

export default MainMenuSocialLinks;
